import { parseIsoDate } from '@/engine/dates';
import { nutrientMeta } from '@/engine/nutrients';
import type { NutrientKey } from '@/engine/types';

const LOCALE = 'es-ES';

/** Numero en formato espanol: coma decimal y punto de millares. */
export function num(value: number, decimals = 0): string {
  return new Intl.NumberFormat(LOCALE, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
}

/** Un valor desconocido se escribe, no se dibuja como 0. */
export function nutrientValue(key: NutrientKey, value: number | null | undefined): string {
  if (value == null) return '—';
  const meta = nutrientMeta(key);
  const unit = meta.unit === 'ug' ? 'µg' : meta.unit;
  return `${num(value, meta.decimals)} ${unit}`;
}

export function percent(fraction: number, decimals = 0): string {
  return `${num(fraction * 100, decimals)} %`;
}

/** 'YYYY-MM-DD' -> '20/09'. */
export function shortDate(iso: string): string {
  const [, m, d] = iso.split('-');
  return `${d}/${m}`;
}

/** 'YYYY-MM-DD' -> 'sábado, 20 de septiembre'. */
export function longDate(iso: string): string {
  const { year, month, day } = parseIsoDate(iso);
  const date = new Date(Date.UTC(year, month - 1, day));
  return new Intl.DateTimeFormat(LOCALE, {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    timeZone: 'UTC',
  }).format(date);
}

/** Fecha de hoy en hora local, como 'YYYY-MM-DD'. */
export function todayIso(now = new Date()): string {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export { addDays } from '@/engine/dates';

const KG_PER_LB = 0.45359237;

export function kgToDisplay(kg: number, unit: 'kg' | 'lbs'): number {
  return unit === 'kg' ? kg : kg / KG_PER_LB;
}

export function displayToKg(value: number, unit: 'kg' | 'lbs'): number {
  return unit === 'kg' ? value : value * KG_PER_LB;
}
